export default __webpack_public_path__ + "static/media/950G.9ebbf452.pdf";